import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { defineComponent as _defineComponent } from 'vue';
import { encodeReferencePeriodsForQuery, sortReferencePeriods } from '~/functions/referencePeriods';
import { AccountCategory, MetricReportingPeriodType, useChangeReportingPeriodTypeMutation, useGetUserQuery, useUpdateAccountMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditContextAccountDialog',
  props: {
    value: {
      type: Boolean
    },
    accountId: null,
    accountName: null,
    accountWebsite: null,
    accountLogo: null,
    accountType: null,
    accountDefaultReferencePeriods: null,
    accountRequireImpactSubmission: {
      type: Boolean
    },
    accountReportingPeriodType: null
  },
  emits: ["input"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      $axios = _useNuxtApp.$axios;
    var route = useRoute();
    var router = useRouter();
    var _useGetUserQuery = useGetUserQuery(),
      userResult = _useGetUserQuery.result;
    var isOpen = computed({
      get: function get() {
        return props.value;
      },
      set: function set(value) {
        return emit('input', value);
      }
    });
    var name = ref('');
    var website = ref('');
    var logo = ref('');
    var selectedReferencePeriods = ref([]);
    var requireImpactSubmission = ref(true);
    var reportingPeriodType = ref(MetricReportingPeriodType.Annual);
    var initialReportingPeriodType = ref(MetricReportingPeriodType.Annual);
    watch(function () {
      return props.value;
    }, function () {
      var _props$accountDefault, _props$accountReporti;
      name.value = props.accountName || '';
      website.value = props.accountWebsite || '';
      logo.value = props.accountLogo || '';
      selectedReferencePeriods.value = sortReferencePeriods((_props$accountDefault = props.accountDefaultReferencePeriods) !== null && _props$accountDefault !== void 0 ? _props$accountDefault : []);
      requireImpactSubmission.value = props.accountRequireImpactSubmission !== false;
      var periodType = (_props$accountReporti = props.accountReportingPeriodType) !== null && _props$accountReporti !== void 0 ? _props$accountReporti : MetricReportingPeriodType.Annual;
      reportingPeriodType.value = periodType;
      initialReportingPeriodType.value = periodType;
    }, {
      immediate: true
    });
    var isPortfolio = computed(function () {
      return props.accountType === AccountCategory.Portfolio;
    });
    var isIxAdmin = computed(function () {
      var _userResult$value, _userResult$value$get;
      return Boolean((_userResult$value = userResult.value) === null || _userResult$value === void 0 ? void 0 : (_userResult$value$get = _userResult$value.getUser) === null || _userResult$value$get === void 0 ? void 0 : _userResult$value$get.isAdmin);
    });
    var reportingPeriodTypeHint = computed(function () {
      if (reportingPeriodType.value === initialReportingPeriodType.value) {
        return '';
      }
      if (reportingPeriodType.value === MetricReportingPeriodType.Quarterly) {
        return 'Switching to quarterly applies to metrics that support quarterly input. Annual data is kept; annual values are recalculated once quarterly values are entered.';
      }
      return 'Switching to annual applies to portfolio companies. Quarterly data is kept but may become outdated once new yearly values are entered.';
    });
    var accountTypeLabel = computed(function () {
      if (props.accountType === AccountCategory.Portfolio) return 'portfolio';
      if (props.accountType === AccountCategory.Venture) return 'company';
      return 'account';
    });
    var dialogTitle = computed(function () {
      return isPortfolio.value ? 'Edit portfolio' : "Edit ".concat(accountTypeLabel.value);
    });
    var _useUpdateAccountMuta = useUpdateAccountMutation(),
      updateAccount = _useUpdateAccountMuta.mutate,
      updateAccountLoading = _useUpdateAccountMuta.loading;
    var _useChangeReportingPe = useChangeReportingPeriodTypeMutation(),
      changeReportingPeriodType = _useChangeReportingPe.mutate,
      reportingPeriodLoading = _useChangeReportingPe.loading;
    var saving = computed(function () {
      return updateAccountLoading.value || reportingPeriodLoading.value;
    });
    var handleReferencePeriodChange = function handleReferencePeriodChange(selected) {
      selectedReferencePeriods.value = sortReferencePeriods(selected);
    };
    var onLogoUpload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var _response$data, formData, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (file) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              formData = new FormData();
              formData.append('file', file);
              _context.next = 7;
              return $axios.post('/api/upload', formData, {
                headers: {
                  'content-Type': 'multipart/form-data'
                }
              });
            case 7:
              response = _context.sent;
              if ((_response$data = response.data) !== null && _response$data !== void 0 && _response$data[0]) {
                logo.value = response.data[0];
              }
              _context.next = 14;
              break;
            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](2);
              window.$nuxt.$emit('userError', _objectSpread(_objectSpread({}, _context.t0), {}, {
                color: 'red'
              }));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 11]]);
      }));
      return function onLogoUpload(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var onSave = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var saveTasks, nextMaYears, currentMaYears, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (props.accountId) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              saveTasks = [];
              if (isPortfolio.value) {
                saveTasks.push(updateAccount({
                  input: {
                    id: props.accountId,
                    name: name.value,
                    defaultReferencePeriods: selectedReferencePeriods.value,
                    requireImpactSubmission: requireImpactSubmission.value
                  }
                }));
                if (reportingPeriodType.value !== initialReportingPeriodType.value) {
                  saveTasks.push(changeReportingPeriodType({
                    portfolioId: props.accountId,
                    reportingPeriodType: reportingPeriodType.value
                  }));
                }
              } else {
                saveTasks.push(updateAccount({
                  input: {
                    id: props.accountId,
                    name: name.value,
                    logo: logo.value,
                    website: website.value
                  }
                }));
              }
              _context2.next = 6;
              return Promise.all(saveTasks);
            case 6:
              initialReportingPeriodType.value = reportingPeriodType.value;
              if (!isPortfolio.value) {
                _context2.next = 15;
                break;
              }
              nextMaYears = selectedReferencePeriods.value.length ? encodeReferencePeriodsForQuery(selectedReferencePeriods.value) : undefined;
              currentMaYears = typeof route.query.maYears === 'string' ? route.query.maYears : Array.isArray(route.query.maYears) ? route.query.maYears[0] : undefined;
              if (!(currentMaYears !== nextMaYears)) {
                _context2.next = 15;
                break;
              }
              query = _objectSpread({}, route.query);
              if (nextMaYears) {
                query.maYears = nextMaYears;
              } else {
                delete query.maYears;
              }
              _context2.next = 15;
              return router.replace({
                query: query
              });
            case 15:
              window.$nuxt.$emit('userMsg');
              isOpen.value = false;
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function onSave() {
        return _ref3.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      $axios: $axios,
      route: route,
      router: router,
      userResult: userResult,
      isOpen: isOpen,
      name: name,
      website: website,
      logo: logo,
      selectedReferencePeriods: selectedReferencePeriods,
      requireImpactSubmission: requireImpactSubmission,
      reportingPeriodType: reportingPeriodType,
      initialReportingPeriodType: initialReportingPeriodType,
      isPortfolio: isPortfolio,
      isIxAdmin: isIxAdmin,
      reportingPeriodTypeHint: reportingPeriodTypeHint,
      accountTypeLabel: accountTypeLabel,
      dialogTitle: dialogTitle,
      updateAccount: updateAccount,
      updateAccountLoading: updateAccountLoading,
      changeReportingPeriodType: changeReportingPeriodType,
      reportingPeriodLoading: reportingPeriodLoading,
      saving: saving,
      handleReferencePeriodChange: handleReferencePeriodChange,
      onLogoUpload: onLogoUpload,
      onSave: onSave,
      MetricReportingPeriodType: MetricReportingPeriodType
    };
  }
});